// Created by hejikun on 2017/11/2 0002.
let accompany = [
  {
    path: '/clinic',
    name: '特需门诊',
    component: () => import('@/pages/clinic/index')
    // component: () => import('@/pages/clinic/clinic_new')
  },
  {
    path: '/clinic_new',
    name: '特需门诊',
    // component: () => import('@/pages/clinic/index')
    component: () => import('@/pages/clinic/clinic_new')
  },
  {
    path: '/clinic_detail',
    name: '门诊详情',
    component: () => import('@/pages/clinic/clinic_detail')
  },
  {
    path: '/clinic_department_list',
    name: '科室列表',
    component: () => import('@/pages/clinic/clinic_department_list')
  },
  {
    path: '/hospital_guide',
    name: '智能导诊',
    component: () => import('@/pages/clinic/hospital_guide')
  },
  {
    path: '/clinic_choose_sex',
    name: '选择性别',
    component: () => import('@/pages/clinic/clinic_choose_sex')
  },
  {
    path: '/clinic_doctor_list',
    name: '医生列表',
    component: () => import('@/pages/clinic/clinic_doctor_list')
  },
  {
    path: '/gongren_clinic_new',
    name: '科室列表',
    // component: () => import('@/pages/clinic/gongren_clinic')
    component: () => import('@/pages/clinic/gongren_clinic_new')
  },
  {
    path: '/gongren_clinic',
    name: '科室列表',
    // component: () => import('@/pages/clinic/gongren_clinic')
    component: () => import('@/pages/clinic/gongren_clinic')
  },
  {
    path: '/honghui_clinic',
    name: '专病专诊列表',
    component: () => import('@/pages/clinic/honghui_clinic')
  }
]
export default accompany
